module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [(!_vm.editarLicencas && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    Editar Cadastro de Licenças ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Fechar Edição (Não esqueça de Salvar) ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "5px"
    }
  }, [_vm._v("\n      * Estoque é salvo automaticamente\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('cadastroLicencas', {
    attrs: {
      "idProposta": _vm.idProposta,
      "telaProjeto": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editarLicencas && _vm.usuarioLogado.userType === 'ENTIDADE') ? _c('envioLicencas', {
    attrs: {
      "idProposta": _vm.idProposta
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editarLicencas && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('validacaoLicencas', {
    attrs: {
      "idProposta": _vm.idProposta,
      "nomeProjeto": _vm.nomeProjeto,
      "numeroProjeto": _vm.numeroProjeto
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ab027708!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/licenciamentoAmbiental/licenciamentoAmbientalProjeto.vue
// module id = 2056
// module chunks = 1